import React from 'react';
import PropTypes from 'prop-types';
import { FileExtensionType, QuestionType } from '../../../../../../views/democracy/constants';
import AppMedia from '../../../controls/media/AppMedia';
import { inferMediaType } from '../../../controls/media/mediaLogic';
import ToggleButton from './ToggleButton';
import ActionButton from './ActionButton';

// Колонка «Вопрос»: контролы + текст вопроса/ответа + медиа.
export default function CenterQuestion({ session, flags, dispatch }) {
    const cq = session.currentQuestion;
    const media = Array.isArray(cq?.media) ? cq.media : [];
    const isKahoot = cq?.type === QuestionType.KAHOOT && cq?.kahoot;

    return (
        <div className="ctrl-col">
            <h4>Вопрос</h4>
            <div className="qctrl">
                <ToggleButton
                    on={!!flags.questionIsShow}
                    onLabel="Скрыть вопрос"
                    offLabel="Показать вопрос"
                    onClick={() => (flags.questionIsShow ? dispatch.hideQuestion() : dispatch.showQuestion())}
                />
                <ActionButton label="Передать вопрос" onClick={dispatch.throwQuestion} />
                <ActionButton label="Засчитать вопрос" onClick={dispatch.applyCorrectAnswer} />
                <ToggleButton
                    on={!!flags.answerIsShow}
                    onLabel="Скрыть ответ"
                    offLabel="Показать ответ"
                    onClick={() => (flags.answerIsShow ? dispatch.hideAnswer() : dispatch.showAnswer())}
                />
                <ActionButton label="К следующему" onClick={dispatch.nextQuestion} />
            </div>

            <div className="qdiv" />
            <div className="qsub">Вопрос</div>
            <div className="qbig">{cq?.questionText || '—'}</div>

            {isKahoot && (
                <KahootVotes kahoot={cq.kahoot} answerText={cq.answerText} teams={session.teams || []} />
            )}

            <div className="qans">
                <div className="qsub">Ответ</div>
                <div className="v">{cq?.answerText || '—'}</div>
            </div>

            {media.length > 0 && (
                <div className="mg-media">
                    {[...media].sort((a, b) => (a.orderId ?? a.id) - (b.orderId ?? b.id)).map(m => {
                        const mtype = m.fileExtensionType || inferMediaType(m);
                        return (
                            <div
                                key={m.id}
                                className={`mitem${flags.mediaIdToShow === m.id ? ' on' : ''}`}
                                onClick={() => { if (mtype === FileExtensionType.IMAGE) dispatch.selectMedia(m.id); }}
                            >
                                <AppMedia value={m} type={mtype} disabled />
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}

CenterQuestion.propTypes = {
    session: PropTypes.object.isRequired,
    flags: PropTypes.object.isRequired,
    dispatch: PropTypes.object.isRequired
};

const norm = (s) => (s ?? '').trim();

// Варианты Kahoot + минималистичные цветные точки-голоса команд.
function KahootVotes({ kahoot, answerText, teams }) {
    const options = [kahoot.option1, kahoot.option2, kahoot.option3];

    return (
        <div className="kah">
            {options.map((opt, index) => {
                const correct = norm(opt) !== '' && norm(opt) === norm(answerText);
                const voters = norm(opt) === '' ? [] : teams.filter(t => norm(t.lastAnswerText) === norm(opt));
                return (
                    <div className={`kah-opt${correct ? ' correct' : ''}`} key={index}>
                        <span className="kah-num">{index + 1}</span>
                        <span className="kah-text">{opt || '—'}</span>
                        <span className="kah-dots">
                            {voters.length === 0
                                ? <span className="kah-empty">—</span>
                                : voters.map(t => (
                                    <span className="kah-voter" key={t.teamId} title={t.name}>
                                        <span className="kah-dot" style={{ background: t.color || 'var(--line-2)' }} />
                                        {typeof t.lastAnswerSeconds === 'number' && (
                                            <span className="kah-sec">{t.lastAnswerSeconds}с</span>
                                        )}
                                    </span>
                                ))}
                        </span>
                    </div>
                );
            })}
        </div>
    );
}

KahootVotes.propTypes = {
    kahoot: PropTypes.object.isRequired,
    answerText: PropTypes.string,
    teams: PropTypes.array
};
